// extracted by mini-css-extract-plugin
export var wordContainer = "_i3-0";